import { FacebookShareButton } from 'react-share';
import { FC } from 'react';
import { Box, Center, Text, VStack } from '@chakra-ui/react';
import { Facebook } from '../../assets';
import { getDataTracking } from '../../utils';
import { TrackingLabelProps } from '../../types/global';

export interface FacebookShareProps extends TrackingLabelProps {
  hasSupportText?: boolean;
  quote?: string;
  url: string;
}

export const FacebookShare: FC<FacebookShareProps> = ({
  hasSupportText = true,
  quote,
  url,
  trackingLabel,
}) => (
  <FacebookShareButton
    url={url}
    quote={quote}
    {...getDataTracking(`${trackingLabel}Facebook`)}
  >
    <Center w="140px" h="126px">
      <VStack>
        <Facebook boxSize="64px" />
        {hasSupportText && (
          <Box mt={2}>
            <Text fontSize="md">Facebook</Text>
          </Box>
        )}
      </VStack>
    </Center>
  </FacebookShareButton>
);
